const CSS = `
@keyframes hvOrbit {
  0.0% { left:-6%; top:50%; transform:translate(-50%,-50%) scale(0.6); opacity:0; z-index:0; }
  14.5% { left:15%; top:25%; transform:translate(-50%,-50%) scale(0.75); opacity:0.7; z-index:0; }
  29.1% { left:38%; top:75%; transform:translate(-50%,-50%) scale(1.1); opacity:1; z-index:2; }
  43.6% { left:62%; top:25%; transform:translate(-50%,-50%) scale(0.75); opacity:0.7; z-index:0; }
  58.2% { left:85%; top:75%; transform:translate(-50%,-50%) scale(1.1); opacity:1; z-index:2; }
  72.7% { left:106%; top:50%; transform:translate(-50%,-50%) scale(0.6); opacity:0; z-index:2; }
  100% { left:106%; top:50%; transform:translate(-50%,-50%) scale(.6); opacity:0; z-index:0; }
}
@keyframes hvWarm { 0%,100% { color:#D9915F; text-shadow:0 0 6px rgba(193,127,89,.35); } 8.2% { color:#FFE2C4; text-shadow:0 0 10px rgba(243,197,143,.9), 0 0 22px rgba(193,127,89,.7); } 21.3% { color:#D9915F; text-shadow:0 0 6px rgba(193,127,89,.35); } }
.hv-orb { position:absolute; width:4.19em; height:4.19em; border-radius:50%; pointer-events:none; animation: hvOrbit 11s ease-in-out infinite;
  background: radial-gradient(circle at 50% 55%, rgba(255,236,214,.85) 0 7%, rgba(232,180,143,.7) 16%, rgba(193,127,89,.5) 32%, rgba(160,90,55,.15) 52%, transparent 70%); filter: blur(1px); }
@keyframes hvSpark { 0% { opacity:0; transform:translate(-50%,-50%) scale(1); } 1% { opacity:1; } 13% { opacity:0; transform:translate(calc(-50% + var(--dx)), calc(-50% + 1.8em)) scale(.3); } 100% { opacity:0; } }
.hv-spark { position:absolute; width:4px; height:4px; border-radius:50%; background:#F3C58F; box-shadow:0 0 8px 3px rgba(232,160,107,.9); opacity:0; pointer-events:none; z-index:3; animation: hvSpark 11s linear infinite; }
.hv-l { display:inline-block; position:relative; z-index:1; color:#D9915F; text-shadow:0 0 6px rgba(193,127,89,.35); animation: hvWarm 11s linear infinite both; }
`;
const LETTERS = ["A", "i", " ", "V", "E", "S", "T", "A"];
const PATH = [[-6, 50], [15, 25], [38, 75], [62, 25], [85, 75], [106, 50]];
const SEG = 1.6;
const ease = (f) => (f < 0.5 ? 2 * f * f : 1 - 2 * (1 - f) ** 2);
const SPARKS = [1, 2, 3, 4].flatMap((i) => [0.35, 0.8].map((f) => {
  const [x0, y0] = PATH[i - 1], [x1, y1] = PATH[i], e = ease(f);
  return { left: x0 + (x1 - x0) * e, top: y0 + (y1 - y0) * e, delay: (i - 1 + f) * SEG, dx: `${Math.round(Math.random() * 14 - 7)}px` };
}));

export default function HearthVesta() {
  return (
    <span className="relative inline-block whitespace-nowrap normal-case" data-testid="hearth-vesta">
      <style>{CSS}</style>
      {SPARKS.map((k, i) => <span key={`s${i}`} className="hv-spark" style={{ left: `${k.left}%`, top: `${k.top}%`, animationDelay: `${k.delay}s`, "--dx": k.dx }} />)}
      <span className="hv-orb" />
      {LETTERS.map((c, i) => (
        <span key={i} className="hv-l" style={{ animationDelay: `${(i / LETTERS.length) * 7.2 - 0.4}s` }}>{c === " " ? "\u00A0" : c}</span>
      ))}
    </span>
  );
}
